function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.97295 12.3666C7.64741 12.3666 8.29934 12.323 8.91625 12.242V5.48007C8.2994 5.39903 7.64741 5.35547 6.97295 5.35547C3.1219 5.35547 0 6.77138 0 8.51807V9.20395C0 10.9506 3.1219 12.3666 6.97295 12.3666Z",
  fill: "#9BA0AD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.97295 15.8986C7.64741 15.8986 8.29934 15.855 8.91625 15.774V13.792C8.29922 13.873 7.64759 13.9172 6.97295 13.9172C3.61141 13.9172 0.805695 12.8383 0.146653 11.4023C0.0506772 11.6115 0 11.8281 0 12.0501V12.736C0 14.4827 3.1219 15.8986 6.97295 15.8986Z",
  fill: "#9BA0AD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0276 0C13.1766 0 10.0547 1.41592 10.0547 3.16261V3.84849C10.0547 5.59518 13.1766 7.0111 17.0276 7.0111C20.8786 7.0111 24.0006 5.59518 24.0006 3.84849V3.16261C24.0006 1.41592 20.8786 0 17.0276 0Z",
  fill: "#9BA0AD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0276 8.56173C13.6661 8.56173 10.8604 7.48287 10.2013 6.04688C10.1054 6.25598 10.0547 6.47255 10.0547 6.69462V7.3805C10.0547 9.12719 13.1766 10.5431 17.0276 10.5431C20.8786 10.5431 24.0006 9.12719 24.0006 7.3805V6.69462C24.0006 6.47255 23.9499 6.25598 23.8539 6.04688C23.1949 7.48287 20.3892 8.56173 17.0276 8.56173Z",
  fill: "#9BA0AD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0276 12.0891C13.6661 12.0891 10.8604 11.0102 10.2013 9.57422C10.1054 9.78332 10.0547 9.99989 10.0547 10.222V10.9078C10.0547 12.6546 13.1766 14.0705 17.0276 14.0705C20.8786 14.0705 24.0006 12.6546 24.0006 10.9078V10.222C24.0006 9.99989 23.9499 9.78332 23.8539 9.57422C23.1949 11.0102 20.3892 12.0891 17.0276 12.0891Z",
  fill: "#9BA0AD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0276 15.8117C13.6661 15.8117 10.8604 14.7328 10.2013 13.2969C10.1054 13.506 10.0547 13.7226 10.0547 13.9446V14.6305C10.0547 16.3772 13.1766 17.7931 17.0276 17.7931C20.8786 17.7931 24.0006 16.3772 24.0006 14.6305V13.9446C24.0006 13.7226 23.9499 13.5059 23.8539 13.2969C23.1949 14.7328 20.3892 15.8117 17.0276 15.8117Z",
  fill: "#9BA0AD"
});

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/Coins.6ed0ac24.svg";
export { ForwardRef as ReactComponent };